@if (display()) {
  <span bitBadge variant="success" class="tw-w-fit" role="status" [attr.aria-label]="label()">
    {{ label() }}
  </span>
}
